import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function CTABand({
  title = "Ready when you are.",
  sub = "Book a studio session or send us your grails — we'll take it from there.",
}) {
  return (
    <section className="py-24 sm:py-32 border-t border-[#27272a] relative overflow-hidden" data-testid="cta-band">
      <div
        className="absolute -bottom-40 left-1/2 -translate-x-1/2 h-[420px] w-[420px] rounded-full blur-[150px] opacity-20"
        style={{ background: "radial-gradient(circle, #ebb323, transparent 70%)" }}
      />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 relative text-center">
        <Reveal>
          <h2 className="font-display text-4xl sm:text-6xl font-semibold uppercase tracking-tighter leading-[0.9]">
            {title}
          </h2>
          <p className="text-zinc-400 mt-6 max-w-md mx-auto leading-relaxed">{sub}</p>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
            <Link to="/book" className="group inline-flex items-center gap-2 rounded-full bg-gold text-black font-mono text-xs uppercase tracking-[0.15em] px-7 py-4 font-semibold hover:bg-[#d59e19] transition-colors" data-testid="cta-book">
              Book The Studio <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link to="/contact" className="inline-flex rounded-full border border-white/25 hover:border-gold hover:text-gold text-white font-mono text-xs uppercase tracking-[0.15em] px-7 py-4 transition-colors" data-testid="cta-contact">
              Get In Touch
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
